<p class="pricing">
  <span class="symbol">$</span>
  <span class="whole">{{priceInteger()}}<span class="decimal">.</span></span>
  <span class="fraction">{{priceDecimal()}}</span>
</p>
